<template>
  <div>
    <div class="flex flex-row h-12 bg-grey-extralight flex-no-shrink flex-no-grow border-solid border-b border-grey-lightest justify-between">
      <div class="self-center ml-4 text-base font-semibold text-grey-darkest">Documents</div>
      <div v-if="showFullView" @click="(showFullView = false)" class="self-center mr-4 text-grey font-mono font-thin cursor-pointer"><img src="../../assets/Cross.svg" /></div>
    </div>
    <div v-if="!showFullView">
      <div class="flex flex-col bg-white py-3 overflow-y-auto" style="height: calc(100vh - 8rem)">
        <div class="flex flex-col flex-no-shrink flex-no-grow">
          <div class="doc_header">
            <div @click="setActiveDocs('recently uploaded')" v-bind:class="[activeDocs === 'recently uploaded' ? 'text-blue' : 'hover:text-blue']" class="text-grey text-sm cursor-pointer hover:text-blue">Recently Uploaded</div>          
            <div @click="setActiveDocs('old documents')" v-bind:class="[activeDocs === 'old documents' ? 'text-blue' : 'hover:text-blue']" class="text-grey text-sm cursor-pointer">Old Documents</div>
          </div>
        </div>  
        <div class="flex flex-row bg-grey-lightest mb-4" style="height: 0.125rem">
          <div class="w-1/2" v-bind:class="[activeDocs === 'recently uploaded' ? 'bg-blue' : '']"></div>
          <div class="w-1/2" v-bind:class="[activeDocs === 'old documents' ? 'bg-blue' : '']"></div>
        </div>
        <div v-if="activeDocs === 'recently uploaded'" class="flex flex-col flex-no-shrink flex-no-grow px-4">
          <div class="flex mb-3 items-center">
            <div class="font-semibold text-sm" style="color: #4d6189">UPLOADED IN LAST 30 DAYS</div>
            <div @click="fetchCustomerUploadedFiles()" class="bg-orange-lightest text-grey-dark rounded-lg font-semibold border border-orange-light ml-4 px-4 py-1 cursor-pointer">Refresh</div>
          </div>
          <div class="grid_container bg-grey-lightest text-sm" style="border-radius: 3px 3px 0 0; color: #324467">
            <div class="item_header font-semibold">Provider/Customer</div>
            <div class="item_header font-semibold">Category</div>
            <div class="item_header font-semibold"></div>
          </div>
          <div v-if="last30Days.length < 1" class="flex flex-col bg-white m-2 text-grey-darker text-sm flex-no-shrink flex-no-grow">No documents found</div>
          <div class="flex flex-col flex-no-shrink flex-no-grow border border-solid border-light-grey" style="border-top: none; border-radius: 0 0 3px 3px; border-sizing: border-box" v-else>
            <div  v-for="(doc, index) in last30Days" :key="index">
              <PatientReports :doc = doc @fullView = "showFullViewModal"></PatientReports> 
            </div>
          </div>
        </div>
        <div v-if="activeDocs === 'old documents'" class="flex flex-col flex-no-shrink flex-no-grow px-4">
          <div class="grid_container bg-grey-lightest text-sm" style="border-radius: 3px 3px 0 0; color: #324467">
            <div class="item_header font-semibold">Provider/Customer</div>
            <div class="item_header font-semibold">Category</div>
            <div class="item_header font-semibold"></div>
          </div>
            <div v-if="otherDocuments.length < 1" class="flex flex-col bg-white m-2 text-grey-darker text-sm flex-no-shrink flex-no-grow">No documents found</div>
            <div class="flex flex-col flex-no-shrink flex-no-grow border border-solid border-light-grey" style="border-top: none; border-radius: 0 0 3px 3px; border-sizing: border-box" v-else>
              <div v-for="(doc, index) in otherDocuments" :key="index">
                <PatientReports :doc = doc @fullView = "showFullViewModal"></PatientReports> 
            </div>  
          </div>
        </div>
    <div class="fixed pin-b w-full flex flex-row h-12 bg-white border-solid border-t border-grey-lightest px-4 items-center flex-no-shrink flex-no-grow" v-bind:style="$attrs.chatType === 'online' ? 'width: calc(674px - 12rem);' :' width: calc(100% - 16rem);'">
      <div class="flex flex-row mx-auto pb-2">
        <div @click="openUploadDocModal" class="hover:shadow-md self-center bg-blue p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer flex flex-row font-semibold"><img src="../../assets/upload.svg" class="mr-2"><span>Upload</span></div>
      </div>
    </div>
      <div v-if="showModal">
        <div id="overlay" @click="closeModal" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
        <div v-if="showUploadDocModal" class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 600px; left: calc((100vw - 600px)/2); top:150px;">
          <div class="flex flex-col justify-center px-4 py-4 border-b border-solid border-grey-lighter">
            <div class="flex flex-row mb-2 justify-between items-center">
              <div class="align-center text-lg text-left font-semibold py-2"> Upload Documents</div>
              <img @click="closeModal()" class="w-6 h-6 cursor-pointer" src="../../assets/close.png">
            </div>
            <label class="text-grey-darker font-light text-xs">Categories:</label>
            <div class="flex justify-start">
              <div @click="selectFileCategory('lab_report')" v-bind:class="[fileCategory === 'lab_report' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest']" class="flex px-2 py-1 m-1 ml-0 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow">Lab Report</div>
              <div @click="selectFileCategory('diet')" v-bind:class="[fileCategory === 'diet' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest']" class="flex px-2 py-1 m-1 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow">Diet Plan</div>
              <div @click="selectFileCategory('fitness')" v-bind:class="[fileCategory === 'fitness' ? 'bg-blue text-white' : 'bg-white text-grey-darkest border border-solid broder-grey-lightest']" class="flex px-2 py-1 m-1 justify-center items-center cursor-pointer rounded-sm text-xs hover:shadow">Fitness Plan</div>
            </div>
              <div class="flex my-6 justify-center"> 
                <div class="border-b border-solid w-64 h-8 text-align">
                  <p v-if="selectedFiles && selectedFiles.length>0" class="pt-3 text-sm text-grey-darkest truncate">{{selectedFiles[0].name}}</p>
                  <p v-else class="pt-3 text-m truncate text-grey text-sm">Please select a file to upload</p>
                </div>
                <div class="flex">
                  <div class="mx-4 items-center">
                    <div class="flex flex-column">
                      <div class="db-file-upload">
                        <div class="file">
                          <label class="file-label width:100%">
                            <input class="file-input" style="display:none" accept=".pdf, .png, .jpg, .jpeg" type="file" name="chatfile" id="file" ref="file" @change="handleFileUpload($event.target.files)">
                            <div class="hover:shadow-md self-center bg-blue p-2 px-4 rounded text-white text-xs font-light cursor-pointer">Select</div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="selectedFiles && selectedFiles.length>0" class="buttons flex justify-center my-2">
                <div>
                  <button class="hover:shadow-md self-center bg-blue p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer" @click="uploadDoc()">Upload</button>
                </div>
                <div>
                  <button class="hover:shadow-md self-center bg-grey p-2 rounded text-white font-light ml-2 mt-2 text-sm px-4 cursor-pointer" v-on:click="closeModal()">Cancel</button>
                </div>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showFullView">
      <div class="flex flex-col bg-white overflow-y-auto" style="height: calc(100vh - 8rem); font-size: .875rem; color: #324467">
        <div class="pt-2">
          <div class="flex flex-row h-7 border-solid border-b border-grey-lightest">
            <div @click="setActiveResults('results')" v-bind:class="[activeResults === 'results' ? 'text-blue border-solid border-b border-blue' : 'hover:text-blue']" class="text-grey text-sm cursor-pointer pb-2 ml-4 mr-4">Results</div>
            <div @click="setActiveResults('notes')" v-bind:class="[activeResults === 'notes' ? 'text-blue border-solid border-b border-blue' : 'hover:text-blue']" class="text-grey text-sm cursor-pointer pb-2 mr-4">Notes</div>
            <div @click="setActiveResults('reports')" v-bind:class="[activeResults === 'reports' ? 'text-blue border-solid border-b border-blue' : 'hover:text-blue']" class="text-grey text-sm cursor-pointer pb-2">Reports</div>
          </div>
          <div v-show="activeResults === 'results'" v-if="(document.category === 'Prescription')" class="m-4 text-sm">No Results</div>
          <div v-show="activeResults === 'results'" v-else-if="(document.health_assessment_status === null)" class="text-sm m-4">No Results</div>
          <div v-show="activeResults === 'results'" v-else-if="(document.health_assessment_status !== 'done') && (document.health_assessment_status !== undefined)" class="text-sm m-4">Lab results digitization under {{document.health_assessment_status}}</div>
          <div v-show="activeResults === 'results'" v-else-if="document.lab_results && document.lab_results.length < 1" class="text-sm m-4">No Results</div>
          <div v-show="activeResults === 'results'" v-else-if="(document.health_assessment_status === 'done')" v-for="(lab_result, index) in document.lab_results" :key="index" class=" border-radius-3 border-solid border-grey-lightest overflow-y-auto px-2">
            <div class="font-semibold text-sm py-3 px-2">{{lab_result.name}}</div>
            <div></div>
            <div v-for="(result, index) in lab_result.results" :key="index" class="text-grey text-sm flex flex-row flex-no-grow flex-no-shrink justify-between">
              <div class="pb-3 px-2">{{result.test_component_name}}</div>
              <div :class="result.color" class="pb-3 px-2">{{result.result}}</div>
            </div>
          </div>
          <div v-if="(document.category === 'Prescription')" v-show="activeResults === 'notes'" class="m-4 text-sm">No Notes</div>
          <div v-show="activeResults === 'notes'" v-else-if="document.notes.length<1" class="m-4 text-sm">No Notes</div>
          <div class="m-4" v-show="activeResults === 'notes'" v-for="(note, index) in document.notes" :key="index">
            <div class="font-semibold pb-2">{{note.title}}</div>
            <div class="pb-3 leading-normal text-grey">{{note.description}}</div>
          </div>          
          <div v-if="activeResults === 'reports'" class="text-sm flex flex-col flex-no-grow flex-no-shrink" style="max-height: 155px">
            <div class="m-4" v-if="(document.reports === undefined) && (document.category === 'Prescription')" @click="getDocument(document.category, document.id)" data-toggle="modal" data-target="#myModal"><span class="text-blue font-semibold cursor-pointer">{{document.name}}</span></div>
            <div v-else-if="document.reports.length<1" class="m-4 text-sm">No Reports</div>
            <div v-else v-for="(report, index) in document.reports" :key="index"  class="m-4" style="margin-bottom: 0">
              <div @click="getDocument(report.category, report.id)" data-toggle="modal" data-target="#myModal"><span class="text-blue font-semibold cursor-pointer">{{report.name}}</span></div>
            </div>
          </div>
        </div>      
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import documents from '../../api/customer/document'
import PatientReports from './PatientReports'
import _ from 'lodash'
export default {
  components: {
    PatientReports
  },
  data () {
    return {
      modal: false,
      showModal: false,
      fileCategory: null,
      selectedApt: null,
      selectedKey: null,
      selectedFiles: null,
      showUploadDocModal: false,
      activeDocs: 'recently uploaded',
      activeResults: 'results',
      showFullView: false,
      document: null,
      filesUploadedByPatient: []
    }
  },
  computed: {
    ...mapGetters({
      customer: 'configuration/getActivePatientProfile',
      isActiveChatPresent: 'consultation/isActiveChatPresent',
      isActivePastChatPresent: 'pastConsultation/isPastChatPresent',
      activeSection: 'configuration/getActiveSection'
    }),
    isActiveChat: function () {
      if (this.activeSection === 'connected' && this.isActiveChatPresent === true) {
        return 'ongoing'
      } else if (this.activeSection === 'consults' && this.isActivePastChatPresent === true) {
        return 'past'
      }
    },
    otherDocuments: function () {
      if (this.customer && this.customer.details && this.customer.details.documents) {
        let presList = this.customer.details.prescriptions.map(function (el) {
          var o = Object.assign({}, el)
          o.category = 'Prescription'
          return o
        })
        let allDocs = presList.concat(this.customer.details.documents, this.filesUploadedByPatient)
        allDocs.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date)
        })
        let date = new Date()
        let res = date.setTime(date.getTime() - (30 * 24 * 60 * 60 * 1000))
        let resDate = new Date(res)
        let within30Days = allDocs.filter(function (el, index) {
          return resDate < new Date(el.date)
        })
        return _.pullAllBy(allDocs, within30Days)
      }
      return []
    },
    last30Days: function () {
      if (this.customer && this.customer.details && this.customer.details.documents) {
        let presList = this.customer.details.prescriptions.map(function (el) {
          var o = Object.assign({}, el)
          o.category = 'Prescription'
          return o
        })
        let allDocs = presList.concat(this.customer.details.documents, this.filesUploadedByPatient)
        allDocs.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date)
        })
        let date = new Date()
        let res = date.setTime(date.getTime() - (30 * 24 * 60 * 60 * 1000))
        let resDate = new Date(res)
        let within30Days = allDocs.filter(function (el, index) {
          return resDate < new Date(el.date)
        })
        return within30Days
      }
      return []
    }
  },
  methods: {
    fetchCustomerUploadedFiles: function () {
      documents.getCustomerUploadedFiles(this.customer.customerId).then(response => {
        if (response.status === 200) {
          const newData = this.transformUploadedFiles(response.body)
          this.filesUploadedByPatient = newData
        } else {
          this.$toast.open({message: 'Error fetching data', type: 'error', position: 'top-right'})
        }
      }, () => {
        this.$toast.open({message: 'Error fetching data', type: 'error', position: 'top-right'})
      })
    },
    transformUploadedFiles: function (data) {
      if (!data || !Array.isArray(data)) return []
      return data.map(appointment => {
        const appointmentName = appointment.description || ''
        const appointmentDate = appointment.time
        const documents = Array.isArray(appointment.documents) ? appointment.documents : []
        const reports = documents.map(doc => ({id: doc.id || null, name: doc.file_name || ''}))

        return {
          category: 'Others',
          spc_consultation_name: appointmentName,
          date: appointmentDate,
          health_assessment_status: '',
          lab_results: [],
          notes: [],
          reports: reports
        }
      })
    },
    handleFileUpload (files) {
      this.selectedFiles = files
    },
    selectFileCategory: function (category) {
      this.fileCategory = category
    },
    openUploadDocModal: function (apt, key) {
      this.selectedApt = apt
      this.selectedKey = key
      this.showModal = true
      this.showUploadDocModal = true
    },
    closeModal: function () {
      this.showModal = false
      this.showUploadDocModal = false
      this.fileCategory = null
      this.selectedApt = null
      this.selectedKey = null
      this.selectedFiles = null
    },
    getDocument: function (reportType, reportId) {
      documents.fetch(reportType, reportId).then(response => {
        if (response.body.status === 200) {
          window.open(response.body.url, '_blank')
        } else {
          this.$toast.open({
            message: 'Error fetching data',
            type: 'error',
            position: 'top-right'
          })
        }
      }, response => {
      })
    },
    uploadDoc (file) {
      if (!this.fileCategory) {
        this.$toast.open({
          message: 'Please select a document category',
          type: 'error',
          position: 'bottom-right',
          queue: false
        })
        return
      }
      if (this.customer.consultation && !this.customer.consultation.consultationId) {
        this.$toast.open({
          message: 'Cannot Upload documents without a consultation.',
          type: 'error',
          position: 'bottom-right',
          queue: false
        })
        return
      }
      var formData = new FormData()
      formData.append('customer_id', this.customer.customerId)
      formData.append('consultation_id', this.customer.consultation.consultationId)
      formData.append('category', this.fileCategory)
      Array.prototype.forEach.call(this.selectedFiles, function (file) {
        formData.append('files[]', file, file.name)
      })
      if (this.$attrs.chatType === 'offline') {
        this.uploadOffline(formData)
      } else if (this.$attrs.chatType === 'online') {
        this.uploadOnline(formData)
      }
      this.closeModal()
    },
    uploadOffline: function (formData) {
      if (this.activeSection === 'connected') {
        this.$store.dispatch('offlineConsultation/uploadDocuments', formData)
      } else if (this.activeSection === 'consults') {
        this.$store.dispatch('pastOfflineConsultation/uploadDocuments', formData)
      }
    },
    uploadOnline: function (formData) {
      if (this.activeSection === 'connected') {
        this.$store.dispatch('consultation/uploadDocuments', formData)
      } else if (this.activeSection === 'consults') {
        this.$store.dispatch('pastConsultation/uploadDocuments', formData)
      }
    },
    setActiveDocs: function (section) {
      this.activeDocs = section
    },
    setActiveResults: function (resultsSection) {
      this.activeResults = resultsSection
    },
    showFullViewModal: function (fullView, doc) {
      this.showFullView = fullView
      this.document = doc
    }
  },
  mounted () {
    this.fetchCustomerUploadedFiles()
  }
}
</script>

<style scoped>
.grid_container{
  height: 2.2135rem;
  display: grid;
  padding: 10px;
  grid-template-columns: 
    minmax(130px, auto) 
    minmax(90px, 100px) 
    minmax(40px, 70px)
    minmax(20px,23px)   
}

.doc_header{
  padding: 0;
  display: grid;
  height: 28px;
  margin: 0px 1px 0px 1px;
  text-align: center;
  grid-template-columns: 
    auto auto
}

.item_header{
  padding: 0px;
  margin: 0px 1px 0px 1px;
  text-align: left;
}

::-webkit-scrollbar {
  width: 3px;
  height: 50px;
  margin: 21px 0 12px 9px;
  border-radius: 1.5px;
  background-color: #c7cde0;
}

</style>


// WEBPACK FOOTER //
// src/components/Customer/PatientDocs.vue